import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { PartyRoleTypes } from '../../party/model/party-role-types.model';

@Injectable({
    providedIn: 'root'
})
export class PartyRoleTypeEntityService extends EntityCollectionServiceBase<PartyRoleTypes> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('PartyRoleTypes', serviceElementsFactory);
    }
}
